import server from "./server";

export const getDeveloperRequestsApi = async () => {
  const response = await server().get("/developerRequests");
  return response.data;
};

export const getSingleDeveloperRequestApi = async (id) => {
  const response = await server().get(`/developerRequests/${id}`);
  return response.data;
};

export const deleteDeveloperRequestApi = async ({ id }) => {
  const response = await server().delete(`/developerRequests/${id}`);
  return response.data;
};
